import {
  getGlobalCssUrl,
  getComponentCssUrl,
} from '@/components/webcomponents/Global/loadDependency'

// Lazy template creation to avoid calling getCdnUrl at module load time
function createNavPortalMenuStylesTemplate() {
  const t = document.createElement('template')
  t.innerHTML = `
<link href="${getGlobalCssUrl()}" rel="stylesheet" />
<link href="${getComponentCssUrl('NavPortalMenu--wc.css')}" rel="stylesheet" />

`
  return t
}

const getNavPortalMenuStyles = () => createNavPortalMenuStylesTemplate()
export { getNavPortalMenuStyles }
